import { useMemo } from 'react';
import { Configuration, StoresApi } from '@/api';
import { StoreFilters } from '@/api/StoresApi';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';

const useStoreMetricsQuery = (filters?: Partial<StoreFilters>) => {
  const auth = useAuth();
  const storesApi = useMemo(() => new StoresApi(new Configuration(auth)), [auth]);

  const query = useQuery({
    queryKey: ['store-metrics', filters],
    queryFn: () => storesApi.getStoreMetrics(filters),
  });

  return {
    metrics: query.data ?? null,
    storeCount: query.data?.storeCount ?? 0,
    activeStoreCount: query.data?.activeStoreCount ?? 0,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
};

export default useStoreMetricsQuery;
